"use client"

import { SectionContact } from "@/components/section-contact"
import { SectionFocus } from "@/components/section-focus"
import { SectionHero } from "@/components/section-hero"
import { SectionJourney } from "@/components/section-journey"
import { SectionProjects } from "@/components/section-projects"
import { SectionProof } from "@/components/section-proof"
import { SectionSkills } from "@/components/section-skills"
import { SiteFooter } from "@/components/site-footer"
import { SiteHeader } from "@/components/site-header"

export function HomePage() {
  return (
    <>
      <SiteHeader />
      <main>
        <SectionHero />
        {/* Evidence sits first: a reviewer gives this page under a minute. */}
        <SectionProof />
        <SectionFocus />
        <SectionProjects />
        <SectionJourney />
        <SectionSkills />
        <SectionContact />
      </main>
      <SiteFooter />
    </>
  )
}
